import Route from "@ember/routing/route";

export default class BlockStorageVolumesCreateRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }
}
